import {dateFromMedicalDate} from "@/auxillary/date-format";

export const dateComparer = function (operator: string, fieldValue: any, testValue: any): boolean {
    switch (operator) {
        case "after":
            return after(fieldValue, testValue);
            break;
        case "before":
            return before(fieldValue, testValue);
            break;
        default:
            console.warn("Unknown operator type", operator)
    }

    return false;
}


const after = function(fieldValue: any, testValue: any) : boolean
{
    return compareDateFields(fieldValue, testValue) > 0;
}

const before = function(fieldValue: any, testValue: any) : boolean
{
    return compareDateFields(fieldValue, testValue) < 0;
}

function compareNumbers(number: number, number2: number) {
    if (number < number2) return -1;
    if (number > number2) return 1;
    return 0;
}

const compareDateFields = function(fieldValue: any, testValue: any) : number {
    if (fieldValue == null || fieldValue == undefined || fieldValue == "unknown" || fieldValue == "ongoing")
        return 0;

    if (testValue == null || testValue == undefined || testValue == "unknown" || testValue == "ongoing")
        return 0;

    const fieldDateParts = fieldValue.split("-");
    const testDateParts = testValue.split("-");

    // compare year
    if (testDateParts.length == 0 || testDateParts[0] == null) return 0;
    if (fieldDateParts.length == 0 || fieldDateParts[0] == null) return 0;

    const yearComparison = compareNumbers(parseInt(testDateParts[0]), parseInt(fieldDateParts[0]));
    if (yearComparison != 0) return yearComparison;

    // compare month
    if (testDateParts.length < 2 || testDateParts[1] == "UK" || testDateParts[1] == "XX") return 0;
    if (fieldDateParts.length < 2 || fieldDateParts[1] == "UK" || fieldDateParts[1] == "XX") return 0;
    const monthComparison = compareNumbers(parseInt(testDateParts[1]), parseInt(fieldDateParts[1]));
    if (monthComparison != 0) return monthComparison;

    // compare day
    if (testDateParts.length < 2 || testDateParts[2] == "UK"|| testDateParts[2] == "XX") return 0;
    if (fieldDateParts.length < 2 || fieldDateParts[2] == "UK"|| fieldDateParts[2] == "XX") return 0;
    const dayComparison = compareNumbers(parseInt(testDateParts[2]), parseInt(fieldDateParts[2]));
    if (dayComparison != 0) return dayComparison;

    return 0;
}

export const compareMedicalDateFields = function(fieldValues: any, testValues: any, sortingOrder: any) {
    const date1 = dateFromMedicalDate(fieldValues);
    const date2 = dateFromMedicalDate(testValues);
    if (date1 > date2)
        return sortingOrder == "asc"? 1 : -1;
    if (date1 < date2)
        return sortingOrder == "asc"? -1 : 1;
    return 0;
}
